import { useAppDispatch } from "@/app/hooks";
import { PATH_NAME } from "@/constants";
import { resetPassword } from "@/features";
import { toastify } from "@/utils";
import { useFormik } from "formik";
import { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as Yup from "yup";

const ForgotPasswordPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid Email")
        .required("Please fill out this field."),
    }),
    onSubmit: async (values) => {
      setError("");

      try {
        const response = await dispatch(resetPassword(values.email)).unwrap();
        if (response?.status === "FAILED") {
          toastify(response?.message, "error");
          return;
        }
        toastify("Email has been sent to user successfully", "success");
        navigate(PATH_NAME.LOGIN);
      } catch (err) {
        toastify("Failed to send email", "error");
      }
    },
  });

  const {
    values,
    isSubmitting,
    touched,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
  } = formik;

  return (
    <Fragment>
      <div
        className="auth-page-content bg-primary vh-100"
        style={{ paddingTop: 150 }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <div className="text-center mt-2 mb-2">
                    <h5 className="text-primary">Forgot Password?</h5>
                    <p className="text-muted">Reset password with Maralytics</p>
                    <i className="ri-mail-send-line display-5 text-success mb-3"></i>
                  </div>
                  <div>
                    {error && <Alert color="danger">{error}</Alert>}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label>Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                        />
                        {touched.email && errors.email && (
                          <p className="text-danger mt-2">{errors.email}</p>
                        )}
                      </div>

                      <div className="text-center mt-4">
                        <button
                          className="btn btn-primary w-100"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          Reset Password
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0 text-white">
                  Return to{" "}
                  <Link
                    to={PATH_NAME.LOGIN}
                    className="fw-semibold text-white text-decoration-underline"
                  >
                    Sign In
                  </Link>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default ForgotPasswordPage;
